/**
 * Closeout Products App
 * WooCommerce-powered closeout product browser with search, filtering, and cart
 */

import { createApp } from 'vue';
import CloseoutProducts from './components/CloseoutProducts.vue';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('closeout-app');

	if (container) {
		const app = createApp(CloseoutProducts);

		app.config.globalProperties.$wordpress = {
			ajaxUrl: window.jaeckleData?.ajaxUrl || '/wp-admin/admin-ajax.php',
			nonce: window.jaeckleData?.nonce || '',
			siteUrl: window.jaeckleData?.siteUrl || '',
		};

		app.mount('#closeout-app');
	}
});
